import React, { useState } from 'react';
import { faRobot, faBan, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Input, Button, NoInteractionView, alert, AlertType, Modal } from '@quyva/shared-ui';
import axios from 'axios';
import { getUrl } from 'utils';
import { Config } from 'config/envConfig';

const TryBotModal = ({ isOpen, onClose }) => {
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tryBotEmail, setTryBotEmail] = useState('');
    const [tryBotWebsite, setTryBotWebsite] = useState('');

    if (!isOpen) return null;

    const resetState = () => {
        setSubmitted(false);
        setIsSubmitting(false);
        setTryBotEmail('');
        setTryBotWebsite('');
    };

    return (
        <Modal
            title="Try Sales Agent"
            titleIcon={faRobot}
            open={isOpen}
            onClose={() => {
                onClose();
                resetState();
            }}
        >
            <div className='w-[500px] flex flex-col gap-4 px-6 py-6 bg-backgrounds-slate'>

                {!submitted && !isSubmitting && (
                    <div className='text-sm text-texts-secondary300 leading-relaxed'>
                        Provide your email and website URL to try our sales agent. We’ll set it up for your site and email you a ready-to-use bot link, valid for 7 days.
                    </div>
                )}

                {isSubmitting ? (
                    <NoInteractionView viewText={'Submitting ...'} />
                ) : submitted ? (
                    <div className='text-sm text-texts-secondary300'>
                        Your request is received. You will receive the bot link in email in few hours.
                    </div>
                ) : (
                    <>
                        <Input
                            type='email'
                            placeholder='Enter your email address'
                            value={tryBotEmail}
                            onChange={(e) => setTryBotEmail(e.target.value)}
                        />
                        <Input
                            type='text'
                            placeholder='Enter a website url (https://...)'
                            value={tryBotWebsite}
                            onChange={(e) => setTryBotWebsite(e.target.value)}
                        />
                    </>
                )}

                <div className={`flex gap-3 ${submitted ? 'justify-end' : 'justify-between'}`}>

                    {!submitted && (
                        <Button
                            text='Cancel'
                            type='danger'
                            icon={faBan}
                            className='w-1/2 rounded-xl'
                            onClick={() => {
                                onClose();
                                resetState();
                            }}
                        />
                    )}

                    <Button
                        text={submitted ? 'OK' : 'Submit'}
                        type='success'
                        icon={faCheckCircle}
                        className='w-1/2 rounded-xl'
                        onClick={async () => {

                            if (submitted) {
                                onClose();
                                resetState();
                                return;
                            }

                            try {
                                if (!tryBotEmail || !tryBotWebsite) {
                                    alert(AlertType.ERROR, 'Email and website URL are required');
                                    return;
                                }

                                setIsSubmitting(true);
                                const res = await axios.post(
                                    getUrl(`http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/try_me/request`),
                                    {
                                        email: tryBotEmail,
                                        website_url: tryBotWebsite,
                                    }
                                );

                                const data = res.data;

                                if (data?.status !== 'started') {
                                    alert(AlertType.ERROR, data?.message || "We couldn't process your request right now. Please try again after some time.");
                                    return;
                                }

                                setSubmitted(true);

                            } catch (err) {
                                alert(AlertType.ERROR, err?.response?.data?.detail || 'Something went wrong');
                            } finally {
                                setIsSubmitting(false);
                            }
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default TryBotModal;